import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null; // { permissions, role_id, role, username }
let inflight = null;
const listeners = new Set();

const fetchMe = () => {
  if (!inflight) {
    inflight = axios.get(`${API}/auth/me`).then((r) => {
      cache = r.data;
      listeners.forEach((fn) => fn(cache));
      return cache;
    }).catch(() => { cache = { permissions: [], error: true }; listeners.forEach((fn) => fn(cache)); return cache; }).finally(() => { inflight = null; });
  }
  return inflight;
};

export const resetPermissions = () => { cache = null; };
export const hasPermission = (perms, key) => !!perms && (perms.includes("*") || perms.includes(key));

export function usePermissions() {
  const [me, setMe] = useState(cache);
  useEffect(() => {
    if (!localStorage.getItem("token")) return undefined;
    listeners.add(setMe);
    if (!cache) fetchMe();
    return () => listeners.delete(setMe);
  }, []);
  const perms = me?.permissions || [];
  const can = (key) => hasPermission(perms, key);
  const canAny = (...keys) => keys.some((k) => can(k));
  return { me, loaded: !!me, permissions: perms, can, canAny, refresh: fetchMe };
}
